import { createFileRoute } from "@tanstack/react-router";
import { RecordTypeRulesSection } from "./fullRules";

export const Route = createFileRoute(
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/recordTypes/$recordTypeId/rules",
)({
	component: OrgRecordTypeRulesTab,
});

function OrgRecordTypeRulesTab() {
	return (
		<div className="px-5 pb-5">
			<RecordTypeRulesSection stayOnRoute />
		</div>
	);
}
